import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withLDProvider, useLDClient } from 'launchdarkly-react-client-sdk';

import { getInternalAccountId } from '../../../helpers/securityHelper';
import LocalStorage from '../../../helpers/storage/LocalStorage';

const clientSideID = process.env.LAUNCH_DARKLY_KEY;

// generate user bucket for user sessions, including anonymous
let ldUserBucket = LocalStorage.getItem('r1s-ld-user-bucket-int-100');
if (ldUserBucket) {
    try{
        // try to parse value from local storage
        ldUserBucket = parseInt(ldUserBucket, 10)
    }catch(e){
        ldUserBucket = null;
    }
}

if (!ldUserBucket) {
    // assign anonymous users to bucket 1 to 100 (this makes it possible to target users buckets (not quite percentages but something close)
    ldUserBucket = Math.floor(Math.random() * 100) + 1;
    LocalStorage.setItem('r1s-ld-user-bucket-int-100', `${ldUserBucket}`);
}

function InternalLaunchDarklyProvider({ children }) {
    let accountId;
    const intAccountId = getInternalAccountId();
    if (intAccountId !== '') {
        accountId = intAccountId;
    }
    const ldClient = useLDClient();

    useEffect(() => {
        if (accountId && ldClient) {
            // update user identity for logged in users
            ldClient.identify({
                key: accountId,
                anonymous: false,
                custom: {
                    user_bucket: ldUserBucket,
                    account_id: accountId,
                    uri: window?.location?.pathname,
                },
            });
        }
    }, [accountId, ldClient]);

    return <>{children}</>;
}

// default ld config with anonymous user id and uri where user is at
const config = {
    clientSideID,
    user: {
        key: `bucket100_int_${ldUserBucket}`,
        anonymous: true,
        custom: {
            user_bucket: ldUserBucket,
            uri: window?.location?.pathname,
        },
    },
};
export default withLDProvider(config)(InternalLaunchDarklyProvider);

InternalLaunchDarklyProvider.propTypes = {
    children: PropTypes.node,
};
